import { photos } from "./photos";
import storyMomos from "../../components/Blogcont/images/momos1.jpg";
import storyBurger from "../../components/Blogcont/images/burger1.jpg";
import storyFries from "../../components/Blogcont/images/fries1.jpg";
import storySandwich from "../../components/Blogcont/images/sandwich1.jpg";
import storyIcecream from "../../components/Blogcont/images/icecreams.jpg";
import storyRolls from "../../components/Blogcont/images/roll1.jpg";
import storyShakes from "../../components/Blogcont/images/shakes1.jpg";

export const pairingCategories = ["All", "Sweet", "Savoury", "Café moments", "Food stories"];

export const articles = [
  {
    id: "sweet-little-break",
    title: "A sweet little break.",
    category: "Sweet",
    image: photos.rollsClose,
    imageAlt: "Choco chip cookie dough ice cream rolls",
    desc: "Make a little time for dessert, a conversation and the slower part of your day.",
    dishIds: ["choco-chip-cookie-dough-rolls", "strawberry-sundae"],
    body: "Some moments do not need a special occasion. A plate of rolls, a familiar face across the table and a few unhurried minutes are plenty. This pairing brings together two of our dessert ideas for you to explore.",
    tip: "Start with the rolls, then look at the sundae. Confirm the current dessert menu with the café before choosing.",
  },
  {
    id: "sandwich-and-sip",
    title: "A bite. A sip. A catch-up.",
    category: "Savoury",
    image: photos.sandwich,
    imageAlt: "Smoked paneer sandwich",
    desc: "A sandwich-and-shake idea for your next easy afternoon with friends.",
    dishIds: ["smoked-paneer-sandwich", "dairy-milk-shake"],
    body: "Put the phone down for a minute. Make space for a toasted sandwich, a long conversation and something cold to sip. This is an idea for a café visit, not a fixed-price bundle or an active offer.",
    tip: "Explore the sandwich and shake pages, then check current items on your preferred delivery provider.",
  },
  {
    id: "burger-side-story",
    title: "The burger’s side story.",
    category: "Savoury",
    image: photos.burger,
    imageAlt: "Veg cheese burger",
    desc: "A generous bite and a crispy side. A familiar kind of good mood.",
    dishIds: ["veg-cheese-burger", "mr-fries"],
    body: "There is something comforting about a burger and a side. Keep it simple: a generous bite, a little crunch and your favourite company. No dietary suitability is implied by this pairing.",
    tip: "Use the dish pages to explore the burger and fries, and confirm ingredients with the café.",
  },
  {
    id: "afternoon-off",
    title: "Take the afternoon off.",
    category: "Café moments",
    image: photos.store1,
    imageAlt: "Guests at the RollOver counter",
    desc: "Good company, a café table and permission to linger a little.",
    dishIds: ["smoked-paneer-sandwich", "dairy-milk-shake"],
    body: "Not every break needs a plan. Sometimes it is enough to find a table, catch up with someone and let the afternoon slow down. That simple, welcoming idea is the RollOver experience.",
    tip: "Explore a sandwich-and-shake idea, or book the space for a celebration through the celebrations page.",
  },
  {
    id: "crunch-time",
    title: "A little crunch time.",
    category: "Savoury",
    image: photos.fries,
    imageAlt: "French fries",
    desc: "A side to share while you decide what comes next.",
    dishIds: ["mr-fries", "smoked-paneer-sandwich"],
    body: "A small plate can make a conversation feel like a proper break. This savoury pairing is a place to start browsing the full menu.",
    tip: "Share the idea, then order through Swiggy or Zomato.",
  },
  {
    id: "chocolate-mood",
    title: "For the chocolate mood.",
    category: "Sweet",
    image: photos.shake,
    imageAlt: "Dairy milk shake",
    desc: "An unapologetically sweet café-break idea.",
    dishIds: ["choco-chip-cookie-dough-rolls", "dairy-milk-shake"],
    body: "When the craving is chocolate, let that be the plan. The rolls and the shake show how a single mood can connect different pages of the menu.",
    tip: "Ask about ingredients and allergens before making your choice.",
  },
  // Food stories carried over from the previous blog page (café copy, lightly edited).
  {
    id: "story-momos",
    title: "Everything’s better when there are momos around.",
    category: "Food stories",
    image: storyMomos,
    imageAlt: "Steamed momos at RollOver",
    desc: "A Tibetan and Nepalese dumpling, steamed or fried, with chutney on the side.",
    dishIds: [],
    categorySlug: "momos",
    body: "Momos are a traditional Tibetan and Nepalese dumpling, filled and steamed to perfection. Our menu has chicken, paneer and mixed-veg momos, steamed or fried, with peri peri versions for a little heat.",
    tip: "Browse the momos category on the full menu for the current list and prices.",
  },
  {
    id: "story-burgers",
    title: "Life is too short to miss out on burgers.",
    category: "Food stories",
    image: storyBurger,
    imageAlt: "Burger at RollOver",
    desc: "Hand-shaped patties, grilled to order, with cheese and mayo.",
    dishIds: ["veg-cheese-burger"],
    categorySlug: "burgers",
    body: "Our burgers are hand-crafted into perfectly sized patties and grilled to order, for the balance of flavour and texture that a proper burger needs. Veg cheese and chicken cheese are both on the menu.",
    tip: "See the burger pages for prices, then order through Swiggy or Zomato.",
  },
  {
    id: "story-fries",
    title: "Keep your friends and your fries closer.",
    category: "Food stories",
    image: storyFries,
    imageAlt: "French fries at RollOver",
    desc: "Crisp on the outside, soft inside, perfectly salted.",
    dishIds: ["mr-fries"],
    categorySlug: "munchies",
    body: "If you have a hankering for crispy-on-the-outside, creamy-on-the-inside, perfectly salted fries, look no further than the munchies list.",
    tip: "Mr. Fries pairs with any burger or sandwich on the menu.",
  },
  {
    id: "story-sandwiches",
    title: "A sandwich a day keeps the sadness away.",
    category: "Food stories",
    image: storySandwich,
    imageAlt: "Grilled sandwich at RollOver",
    desc: "A sandwich is only as good as what goes into it.",
    dishIds: ["smoked-paneer-sandwich"],
    categorySlug: "sandwiches",
    body: "That is our philosophy with sandwiches: satisfying, toasted and made with fresh ingredients. Smoked paneer, smoked chicken tikka, veg cheese and even a choco cheese sandwich are on the list.",
    tip: "Browse the sandwiches category for the current line-up.",
  },
  {
    id: "story-icecreams",
    title: "Don’t be sad, you deserve an ice cream.",
    category: "Food stories",
    image: storyIcecream,
    imageAlt: "Ice cream cones at RollOver",
    desc: "Cold, refreshing and, most importantly, delicious.",
    dishIds: ["strawberry-sundae"],
    categorySlug: "waffle-cones",
    body: "The joy of walking into an ice cream shop and choosing your favourite flavour is second to none. Waffle cones, sundaes and gourmet plates cover the sweet side of the menu.",
    tip: "Start with the waffle cones, then look at the exotic sundaes.",
  },
  {
    id: "story-rolls",
    title: "Ice cream makes everything better.",
    category: "Food stories",
    image: storyRolls,
    imageAlt: "Ice cream rolls at RollOver",
    desc: "Ice cream and ice cream rolls are not the same thing.",
    dishIds: ["choco-chip-cookie-dough-rolls"],
    categorySlug: "ice-cream-rolls",
    body: "You thought ice cream and ice cream rolls were the same? Rolls are poured onto a cold plate, spread thin, rolled while you watch and finished with toppings. Grab a plate of rolls and make your day special.",
    tip: "Eleven roll flavours are listed under Ice Cream Rolls on the full menu.",
  },
  {
    id: "story-shakes",
    title: "When life gets tough, shake it.",
    category: "Food stories",
    image: storyShakes,
    imageAlt: "Milkshakes at RollOver",
    desc: "Milk, a sweet flavour and ice cream, whisked until frothy.",
    dishIds: ["dairy-milk-shake"],
    categorySlug: "shakes",
    body: "A cold drink made of milk, a sweet flavouring such as fruit or chocolate, and ice cream, whisked until frothy. Oreo, Kit Kat, Ferrero Rocher and cold coffee lead the list.",
    tip: "Every shake on the menu is listed at the same price.",
  },
];

export const findArticle = (id) => articles.find((a) => a.id === id);
